import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6">
      <div className="max-w-lg w-full text-center space-y-8">
        <Logo variant="dark" size="lg" />
        <XCircle size={56} strokeWidth={1} className="text-neutral-400 mx-auto" />
        <div className="sc-overline">Sostegno annullato</div>
        <h1 className="font-display font-light text-4xl" style={{ letterSpacing: "-0.02em" }}>
          Nessun importo addebitato.
        </h1>
        <p className="text-sm text-neutral-500 leading-relaxed">
          Puoi riprovare in qualsiasi momento. Il progetto è ancora aperto alla raccolta.
        </p>
        <Link to="/hotel-pilota" className="sc-btn-primary inline-flex items-center gap-2">
          <ArrowLeft size={14} /> Torna al progetto
        </Link>
      </div>
    </div>
  );
}
